
if($('.hero-swiper').length){  
  hp.swipers = hp.swipers || {};
  var hero_swiper = 
  {
    initialized: false
  };

  hero_swiper.init = function(){
    var delay = parseInt($('input[name=slideShowSpeed]').val());
    var heroSwiperProps = {
      autoplay: {
        delay: delay ? (delay * 1000) : 3000,
        disableOnInteraction: false,
        reverseDirection: true
      },
      speed: 1000,
      navigation: {
        nextEl: ".right-arrow-svg",
        prevEl: ".left-arrow-svg",
      },
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    }
    var heroSwiperMethods = {
      resizeHandler: true,
      a11ySwiper: true,
      init: false,
      swiperEvents: [{
        eventName: "slideChangeTransitionStart",
        eventMethod: function (sw) {
          if (sw.slides.length - 3 === sw.realIndex) {
            $('.left-arrow-svg', sw.$el).removeClass('hidden');
            $('.right-arrow-svg', sw.$el).addClass('hidden');
          } else {
            $('.left-arrow-svg', sw.$el).addClass('hidden');
            $('.right-arrow-svg', sw.$el).removeClass('hidden');
          }
         }
      }, {
        eventName: "touchEnd",
        eventMethod: function (sw) {
          $('.swiper-slide-next', sw.$el).attr('data-swiper-autoplay', '6000');
          $('.swiper-slide-active', sw.$el).attr('data-swiper-autoplay', '6000');
          window.heroSwiperInterval = setTimeout(function(){
            $('.swiper-slide', sw.$el).attr('data-swiper-autoplay', '');
          }, 6000);
        },
      },
      {
        eventName: "touchStart",
        eventMethod: function(){
          window.clearTimeout(window.heroSwiperInterval);
        }
      }]
    }

    $('.hero-swiper .swiper-slide').each(function(k, slide){
      $('.hero-cta', $(slide)).each(function(k, cta){
        $('a', cta).attr('sitecat-position', 'P'+($(slide).index() + 1));
      });
    })

    hero_swiper.instances = hp.swiperInstance('.hero-swiper', heroSwiperProps, heroSwiperMethods, propsModifier);
    hero_swiper.initialized = true;
  }//END init

  function propsModifier(swiper, props){
      var delay = parseInt($('input[name=slideShowSpeed]', $(swiper).parents('.heromarquee')).val());
      var modifiedProps = JSON.parse(JSON.stringify(props));
      modifiedProps.autoplay.delay = delay ? (delay * 1000) : 3000;
      return modifiedProps;
  }

  hp.swipers.hero_swiper=hero_swiper;
}
